// extracted by mini-css-extract-plugin
module.exports = {"admin":"admin___1Unid","admin__logo":"admin__logo___3uNYH","adminLogo":"admin__logo___3uNYH","admin__tiles":"admin__tiles___qZ7Zg","adminTiles":"admin__tiles___qZ7Zg"};